import axiosConfig from "./axiosConfig";

const deleteSiteArtifact = async (
  authToken: string,
  siteId: string,
  artifactGuid: string
): Promise<void> => {
  await axiosConfig.delete(`/site/${siteId}/artifacts/${artifactGuid}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default deleteSiteArtifact;
